import { useState, useLayoutEffect } from 'react';
import { useWallet } from '@web3/base-hooks';
import { WalletAddress } from '@web3/base-utils';
import { create } from 'zustand';

interface BybitWalletStore {
  bybitWalletAddresses: WalletAddress[];
  setBybitWalletAddresses: (bybitWalletAddresses: WalletAddress[]) => void;
}

const useBybitWalletStore = create<BybitWalletStore>((set, get) => ({
  bybitWalletAddresses: [],
  setBybitWalletAddresses: (bybitWalletAddresses: WalletAddress[]) =>
    set({ bybitWalletAddresses }),
}));

export const useBybitWallet = () => {
  const { bybitWalletAddresses, setBybitWalletAddresses } =
    useBybitWalletStore();
  const {
    isBybitWallet,
    walletAddresses,
    walletIsReady,
    thirdConnected,
    isThird,
  } = useWallet();

  const initThirdAddresses = async () => {
    const bybitWalletInfo = await window?.top.bybitWallet.request({
      method: 'getWalletInfo',
    });

    if (!bybitWalletInfo?.addressChain) return;
    setBybitWalletAddresses(
      bybitWalletInfo?.addressChain.map((item) => {
        return {
          walletAddress: item.address,
          chainId: +item.chainId,
        };
      })
    );
  };

  useLayoutEffect(() => {
    if (!isBybitWallet) return;
    if (!walletIsReady) return;

    if (thirdConnected) {
      initThirdAddresses();
      return;
    }
  }, [isBybitWallet, walletIsReady, thirdConnected]);

  return {
    walletAddresses: isThird ? bybitWalletAddresses : walletAddresses,
    initThirdAddresses,
  };
};
